$(function () {
    $('.vacancy-form__block').on('submit', function (e) {
        //- Остановка отправки формы https://learn.javascript.ru/forms-submit
        e.preventDefault();
        //- Переменная для отправки формы
        var $this = $(this);

        //- Валидация ------------------------------


        //- Получаем все данные из инпутов а так же создаем регулярное выражение на проверку email
        var name = $this.find('input[name=name]').val();
        var phone = $this.find('input[name=phone]').val();
        var email = $this.find('input[name=email]').val();
        var text = $this.find('input[name=message]').val();
        var namePar = $this.find('input[name=name]').parent();
        var phonePar = $this.find('input[name=phone]').parent();
        var emailPar = $this.find('input[name=email]').parent();
        var textPar = $this.find('input[name=message]').parent();
        var pattern = /^[a-z0-9_-]+@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i;
        var successEmail = false;


        //- Проверка на пустое поле
        if (name.length !== 0) {
            //- Проверка выполнена успешно (поле заполнено)
            namePar.removeClass('wrong');
        } else {
            //- Проверка неудачна (поле пустое)
            namePar.addClass('wrong');
        };

        //- Проверка на пустое поле
        if (phone.length !== 0) {
            //- Проверка выполнена успешно (поле заполнено)
            phonePar.removeClass('wrong');
        } else {
            //- Проверка неудачна (поле пустое)
            phonePar.addClass('wrong');
        }

        //- Проверка на пустое поле
        if (email.length !== 0) {
            //- Проверка выполнена успешно (поле заполнено)
            emailPar.removeClass('wrong');

            //- Проверка на соответсвие регулярному выражению
            if (email.search(pattern) == 0) {
                //- Проверка выполнена успешно (значение в поле ввода соответсвует регулярному выражению)
                emailPar.removeClass('wrong');
                successEmail = true;
            } else {
                //- Проверка неудачна (значение в поле ввода НЕ соответсвует регулярному выражению)
                emailPar.addClass('wrong');
            }

        } else {
            //- Проверка неудачна (поле пустое)
            emailPar.addClass('wrong');
        }


        //- Проверка на пустое поле
        if (text.length !== 0) {
            //- Проверка выполнена успешно (поле заполнено)
            textPar.removeClass('wrong');
        } else {
            //- Проверка неудачна (поле пустое)
            textPar.addClass('wrong');
        }

        //- Проверка на соответсвие всех полей необходимым проверкам
        if ($this.find('.wrong').length == 0) {
            //- Конец валидации ----------------------------------------------

            $this.trigger('precapcha');
        }
    });

    $('.vacancy-form__block').on('postcapcha', function (e) {
        var $this = $(this);
        //console.log('submit');
        //feedbackThanks.openModal();
        //feedbackModal.closeModal();


        var fd = new FormData(this);
        //- Выполнить ajax отправку данных на сервер
        $.ajax({
            url: $this.attr('action'), // Файл в который отправить данные
            type: $this.attr('method'), // Метод отправки данных
            data: fd, // Получить все данные формы  https://ruseller.com/jquery?id=8
            processData: false,
            contentType: false,
            success: function () { // Функция выполняемая в случае успешной отправки формы
                //- Очистить форму после отправки
                $this[0].reset();
                console.debug('vacancy sended');
                //feedbackThanks.openModal();
                //feedbackModal.closeModal();
            }
        });
        $this.trigger('afterrequest');
    });
})

